"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            height: constants_1.MIN_TARGET_SIZE,
            top: '50%',
            left: 0,
            right: 0,
            transform: 'translateY(-50%)'
        },
        '&:not([data-is-disabled=true])': {
            cursor: 'pointer'
        },
        '&[data-is-disabled=true]': {
            opacity: 0.3,
            color: theme.grey3
        }
    },
    switch: {
        boxSizing: 'border-box',
        width: 28,
        height: 16,
        color: theme.grey4,
        borderRadius: 2,
        backgroundColor: 'currentColor',
        overflow: 'hidden',
        boxShadow: `0 0 0 0 ${theme.indigoPastel2}`,
        transition: `box-shadow 150ms linear 0ms, background-color 100ms linear 0ms`,
        position: 'relative',
        order: 2,
        '&::before': {
            content: '""',
            position: 'absolute',
            borderRadius: 1,
            top: 2,
            left: 2,
            width: 12,
            bottom: 2,
            backgroundColor: theme.white1,
            transformOrigin: 'center',
            transform: 'translateX(0)',
            transition: 'transform 50ms linear 0ms'
        },
        '&[data-has-focus=true]': {
            boxShadow: `0 0 0 ${constants_1.FOCUS_OUTLINE_WIDTH}px ${theme.indigoPastel2}`
        },
        '&[data-is-on=true]': {
            color: theme.indigo3,
            '&::before': {
                transform: 'translateX(12px)'
            }
        }
    },
    label: {
        fontSize: 12,
        fontColor: theme.grey3,
        fontWeight: 400,
        lineHeight: '14px',
        color: theme.grey3,
        '&[data-is-on=true]': {
            color: theme.grey1
        },
        '&:not([data-is-inverted=true])': {
            order: 3,
            marginLeft: 5
        },
        '&[data-is-inverted=true]': {
            order: 1,
            marginRight: 7
        }
    },
    label2: {
        fontSize: 12,
        fontColor: theme.grey3,
        fontWeight: 400,
        lineHeight: '14px',
        color: theme.grey3,
        '&[data-is-on=true]': {
            color: theme.grey1
        },
        '&:not([data-is-inverted=true])': {
            order: 1,
            marginRight: 5
        },
        '&[data-is-inverted=true]': {
            order: 3,
            marginLeft: 7
        }
    },
    input: {
        position: 'absolute',
        zIndex: 0,
        transform: 'translateX(-200%)'
    }
});
//# sourceMappingURL=switch.style.js.map